 <template>
  <v-dialog v-model="dialog" persistent :max-width="600">
    <v-card class="pt-2 pl-0 pr-0">
      <v-card-title
        class="headline-6"
        :class="{ 'subtitle-2': $vuetify.breakpoint.xs }"
        style="word-break: normal; !important"
      >
        {{
          !pool || !pool.id
            ? "Novo Pool Virtual"
            : "Atualizando Pool Virtual " + pool.nome
        }}
      </v-card-title>

      <v-form ref="form" lazy-validation :class="{ 'overflow-y-hidden': true }">
        <v-row class="ma-0 d-flex justify-center mb-n3">
          <v-col cols="5" class="ml-8 mr-8">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ "*" + $vuetify.lang.t("$vuetify.NOME") }}:</span
              >
            </v-row>
            <v-row md="3">
              <v-text-field
                v-model.trim="pool.nome"
                dense
                single-line
                solo
                max-width="200"
                :rules="rules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="5" class="ml-n2 mr-8">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ "*" + $vuetify.lang.t("$vuetify.CONTRATO") }}:</span
              >
            </v-row>
            <v-row md="2">
              <v-autocomplete
                :items="contracts"
                v-model="pool.contrato"
                solo
                dense
                item-text="nome"
                return-object
                :rules="contractRules"
              ></v-autocomplete>
            </v-row>
          </v-col>

          <v-col cols="5" class="ml-8 mr-8">
            <v-row>
              <span
                class="text-right subtitle-2 font-weight-bold grey--text text--lighten-1"
              >
                {{ "*Tamanho do Pool (GB)" }}:</span
              >
            </v-row>
            <v-row md="3">
              <v-text-field
                v-model.trim="pool.tamanhoGB"
                dense
                single-line
                solo
                max-width="200"
                type="number"
                :rules="numberRules"
              ></v-text-field>
            </v-row>
          </v-col>

          <v-col cols="5" class="ml-6 mt-2">
            <v-checkbox
              v-model="pool.estrangularBanda"
              color="blue darken-2"
              dense
              label="Estrangular banda"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-form>

      <v-divider></v-divider>

      <v-card-actions>
        <v-lazy :options="{ threshold: 0.6 }" transition="slide-x-transition">
          <span class="ml-4 caption red--text" v-show="message">{{
            message
          }}</span>
        </v-lazy>

        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-2"
          text
          @click="
            $refs.form.resetValidation();
            $refs.form.reset();
            close();
            cleanFields();
          "
        >
          {{ $vuetify.lang.t("$vuetify.CANCELAR") }}
        </v-btn>

        <v-btn
          color="blue darken-2"
          text
          @click="send(pool)"
          :loading="isLoading"
        >
          {{ $vuetify.lang.t("$vuetify.ENVIAR") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  components: {},
  props: {
    close: Function,
    dialog: Boolean,
    color: String,
    send: Function,
    pool: Object,
    isLoading: Boolean,
    message: String,
  },
  methods: {
    cleanFields() {},
  },
  data() {
    return {
      loading: false,
      contracts: [],
      rules: [
        (v) =>
          (v && v.length >= 1) ||
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
      numberRules: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && !isNaN(Number(v))) ||
          this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
      contractRules: [
        (v) => v || this.$vuetify.lang.t("$vuetify.CAMPO_OBRIGATORIO"),
      ],
    };
  },
  created: function () {
    this.$root.$on("invalidateFields", () => {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.cleanFields();
    });

    this.$get("/contrato/all", {}).then((response) => {
      this.contracts = response.data;
    });
  },
};
</script>